const KEY = 'grav-last-tenant'

/**
 * The tenant slug this browser last signed in with, offered back on the
 * login form.
 *
 * <p>It replaces a hard-coded 'pilot-nbfc' default, which was right for
 * exactly one lender and wrong — silently, on a field an admin skims past —
 * for every other. Empty is the honest starting state: it makes the field
 * ask rather than assert.</p>
 *
 * <p>Written only after the server accepts the login, so a typo never
 * becomes tomorrow's default. localStorage can throw in private windows and
 * under blocked site data, so both sides swallow failure: forgetting the
 * slug costs one retyped word.</p>
 */
export const lastTenantSlug = read()

function read(): string {
  try {
    return localStorage.getItem(KEY) ?? ''
  } catch {
    return ''
  }
}

export function rememberTenantSlug(slug: string): void {
  if (!slug) return
  try {
    localStorage.setItem(KEY, slug)
  } catch {
    // Storage unavailable — the field just starts empty next time.
  }
}
